<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px"
    height="30.3px" viewBox="0 0 30.3 30.3" style="enable-background:new 0 0 30.3 30.3;" xml:space="preserve" class="kebab-menu-icon">
    <path fill="currentColor" class="st0" d="M18.7,15.2c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3C17.3,12,18.7,13.4,18.7,15.2z
    M15.5,22.5c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3C18.7,24,17.3,22.5,15.5,22.5z M15.5,1.4
    c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3C18.7,2.9,17.3,1.4,15.5,1.4z"/>
  </svg>
</template>
